import { useState, useEffect } from 'react';
import React from 'react';
import axios from 'axios';
import moment from 'moment';
import './alt.css'; // 引用全局样式文件

export default function Alt({ symbols }) {
  const [data, setData] = useState([]);

  const fetchData = async (symbolsArray) => {
    try {
      const requests = symbolsArray.map(symbol => axios(`btc?symbol=${symbol}`));
      const results = await Promise.all(requests);
      setData(results.map(result => result.data));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(symbols);
    const intervalId = setInterval(() => {
      fetchData(symbols);
    }, 1000 * 3);
    return () => clearInterval(intervalId);
  }, [symbols]);

  return (
    <table className="gray margin-top-xs" cellSpacing="10">
      <tbody>
        {data.map((item, index) => (
          <tr key={symbols[index]}>
            <td style={{ textAlign: 'center' }}>{symbols[index]}</td>
            <td>|</td>
            <td style={{ textAlign: 'center', color: '#f60' }}>
              {item.price ? Number.parseFloat(item.price) : ''}
            </td>
            <td>|</td>
            <td>{moment(item.date).format('HH:mm:ss')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
